// React imports.
import React, { Component } from "react";

// App imports.


const IntroPage1 = ({ state }) => (
     <div >
          <h2>Introduction</h2>
          <br/>
          <p>All LIHEAP State Grant Recipients are required to report LIHEAP Performance Measures Data on an annual basis in Module 2 of the <em>LIHEAP Performance Data Form</em>. This includes data for four developmental Performance Measures that furnish LIHEAP Grant Recipients, OCS, and the public with important information to understand and measure the impact of LIHEAP assistance provided by state Grant Recipients.</p>
          <p>This tool is designed to help you: </p>
          <ol>
               <li>Better understand your own Performance Measures;<br />
               </li>
               <li>Compare your Performance Measures with other Grant Recipients; and <br />
               </li>
               <li>Identify ways to potentially improve your program&rsquo;s performance. </li>
          </ol>
          <p>Please click <em>Next </em>to continue. </p>
     </div>
);

export default IntroPage1;
